import React, { useState, MouseEvent, useEffect } from 'react';
import { IconButton, Box, Popover, ClickAwayListener, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import InfoIcon from '../../../assets/icons/info-icon';
import useStyles from './styles';
import DeviceDetailComponent from '../../device-details';
import { AppState } from '../../../store';
import { clearDeviceState, getDeviceByKey } from '../../../store/devices/actions';
import { setSelectedEntityByDeviceId } from '../../../store/search/actions';

const DeviceDetailQuickLook = () => {
  const selectedDevice = useSelector((state: AppState) => state.devices.selectedDevice);
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const deviceKey = selectedEntity?.deviceKey;
  const classes = useStyles();

  const dispatch = useDispatch();
  const { deviceId } = useParams<{ deviceId: string }>();

  const [iconButtonReference, setIconButtonReference] = useState<HTMLElement | null>(null);
  const open = Boolean(iconButtonReference);
  const offset = iconButtonReference ? iconButtonReference.offsetLeft : 0;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setIconButtonReference(event.currentTarget.parentElement);
  };
  const clickAway = () => {
    setIconButtonReference(null);
  };

  useEffect(() => {
    if (open) {
      if (!selectedEntity && deviceId) dispatch(setSelectedEntityByDeviceId(deviceId));
      if (
        selectedEntity &&
        deviceKey &&
        (!selectedDevice || deviceKey !== selectedDevice.device?.deviceKey)
      )
        dispatch(getDeviceByKey({ deviceKey }));
      else if (!deviceKey) dispatch(clearDeviceState());
    }
  }, [selectedEntity, deviceId, open]);

  return <>
    <Box>
      <IconButton
        id="infoButton"
        className={classes.deviceDetailsIcon}
        color="primary"
        onClick={handleClick}
        size="large">
        {open && !selectedEntity ? (
          <CircularProgress className={classes.spinner} size={20} />
        ) : (
          <InfoIcon />
        )}
      </IconButton>
    </Box>
    {open && (
      <Popover
        open={open && !!selectedEntity}
        anchorEl={iconButtonReference}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <ClickAwayListener onClickAway={clickAway}>
          <div style={{ maxWidth: `calc(100vw - ${offset}px - 3rem` }}>
            <DeviceDetailComponent notEditable details={selectedDevice} />
          </div>
        </ClickAwayListener>
      </Popover>
    )}
  </>;
};

export default DeviceDetailQuickLook;
